import { noop } from "lodash";
import { t } from "@/i18n-js/instance";
import { useJoinSpace } from "@circle-react/components/Spaces/hooks";
import { usePunditUserContext } from "@circle-react/contexts";
import { isCommunityAdmin } from "@circle-react/helpers/communityMemberHelpers";
import { isSpaceMember } from "@circle-react/helpers/spaceHelpers";
import type { Space } from "@circle-react/types";
import { Button } from "@circle-react-uikit/Button";

export interface CourseEnrollActionProps {
  space: Space;
}

export const CourseEnrollAction = ({ space }: CourseEnrollActionProps) => {
  const { isSubmitting, joinSpace } = useJoinSpace({
    space,
  });
  const { currentCommunityMember, isViewOnlyMasquerading } =
    usePunditUserContext();
  const isAdmin = isCommunityAdmin(currentCommunityMember);
  const { is_private: isPrivate } = space;

  if (
    isSpaceMember(space) ||
    (isPrivate && !isAdmin) ||
    !currentCommunityMember
  ) {
    return null;
  }
  return (
    <Button
      large
      variant="primary"
      type="button"
      onClick={isViewOnlyMasquerading ? noop : joinSpace}
      data-testid="join-space"
    >
      {t(isSubmitting ? "courses.enrolling" : "courses.enroll")}
    </Button>
  );
};
